import { NullablePick } from "@hex-insights/core";
import { Person, UserNameFragment } from "../../../Utilities";
import * as PersonFormat from "../Person";
import * as Fields from "./fields";

export { Fields };

/**
 * Formats the full name of the given instance.
 */
export function name(instance: UserNameFragment) {
	if (instance.isCurrent) {
		return "You";
	}
	return instance.person ? PersonFormat.name(instance.person) : Fields.email(instance.email);
}

/**
 * Formats the role of the given instance (depending on what type of person it is, if there is one).
 */
export function role(instance: {
	person: {
		employee: NullablePick<Person["employee"], "jobTitle">;
		guardian: NullablePick<Person["guardian"], "id">;
	} | null;
}) {
	if (!instance.person) {
		return "User";
	}
	return PersonFormat.role(instance.person);
}
